<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vr3ay2/tc-custom/9781467457422.jpg?1742010856607" alt="This image is the cover for the book The Psalms as Christian Praise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Psalms as Christian Praise
      </h1>
      <p class="bookDescription body article font2">
        <p>Two respected scholars explore the heart of the Psalms</p><p>Following in the style of their companion volumes, <i>The Psalms as Christian Worship</i> and <i>The Psalms as Christian Lament</i>, Bruce Waltke and James Houston now explore the depths of Christian praise. Each volume uniquely blends verse-by-verse commentary with a history of Psalms interpretation in the church from the time of the apostles to the present. </p><p>Since praise is the essence of the book of Psalms, Waltke and Houston have narrowed the focus to Book IV of the Psalter (Psalms 90-106), which magnify God and proclaim him king. To give voice to the psalmist, the authors (carefully) translate and explain each psalm and summarize its theological message. This is followed by listening to the voice of godly churchmen whose comments have stood the test of time. <i>The Psalms as Christian Praise</i> is ideal for anyone seeking to better understand the praise of Israel as found in the Psalms and how Christians also use these Psalms in worship.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce K. Waltke, James M. Houston
      </h2>
      
      <p class="authorDescription body article"><B>Bruce K. Waltke</B>&#160;is professor emeritus of biblical studies at Regent College, Vancouver, and distinguished professor emeritus of Old Testament at Knox Theological Seminary, Fort Lauderdale. He was a translator of the New American Standard Version of the Bible and is also a member of the committee responsible for the New International Version.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b686ff14